import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile?: boolean;
  }>()
  .create(({ theme, isLayoutMobile }) => ({
    ticketDetails: {
      display: 'flex',
      flexDirection: isLayoutMobile ? 'column' : 'row'
    },
    // left column
    ticketDetailsColumnLeft: {
      paddingRight: isLayoutMobile ? 0 : theme.spacing(3),
      overflowX: 'hidden',
      width: '100%',
      '& > *': {
        marginBottom: theme.spacing(3)
      }
    },
    // right column
    ticketDetailsColumnRight: {
      marginBottom: theme.spacing(5),
      padding: 0,
      width: isLayoutMobile ? '100%' : '23.75rem',
      '& > :first-of-type': {
        marginTop: 0
      }
    },
    columnRightSection: {
      margin: `${theme.spacing(2)} 0`
    },
    columnRightSectionContent: {
      paddingLeft: theme.spacing(2)
    }
  }));

export default useStyles;
